import AppContext from "PFApp/app_context";
import EchartsWrapper from "PFCore/helpers/echarts_wrapper";
import { useSkillsHistQuery } from "PFCore/hooks/queries/insights/use_skills_hist_query";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import BarPreview from "../../previews/bar_preview";
import { SkillsHistChartConfig } from "./configs/skills_hist_chart_config";

export const SkillsHistChart = () => {
  const {
    store: {
      pages: {
        insights: { selectedFilters }
      }
    }
  } = useContext(AppContext);

  const { t } = useTranslation("insights");

  const { data, isLoading, error } = useSkillsHistQuery(
    {
      params: selectedFilters
    },
    {
      select: (data) => data.skills_hist
    }
  );

  if (isLoading) {
    return <BarPreview content={t("loading")} animated />;
  }

  if (error) {
    return <BarPreview content={t("noData")} />;
  }

  const formatTitle = (name, value) =>
    `${t("skillsPerUser")}: <b>${name}</b><br />${t("noOfUsers")}: <b>${value}</b>`;

  return (
    <div>
      <h2>{t("NoOfSkills")}</h2>
      {data.length > 0 ? (
        <EchartsWrapper height={500} options={SkillsHistChartConfig(formatTitle, t("saveImage"), data)} />
      ) : (
        <BarPreview content={t("noData")} />
      )}
    </div>
  );
};
